import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./components/Login";
import PrivateRoute from "./components/PrivateRoute";
import Redirect from "./components/utils/Redirect";
import Dashboard from "./pages/dashboard/Dashboard";
import Settings from "./pages/settings/Settings";
import VerifyMail from "./components/VerifyMail";
import Reports from "./pages/reports/Reports";
import RewardsOverview from "./pages/rewards/RewardsOverview";
import InviteCodesOverview from "./pages/invite-codes/InviteCodesOverview";
import TaskPage from "./pages/tasks/TaskPage";
import Orders from "./pages/orders/Orders";
import OrdersOverview from "./pages/orders/OrdersOverview";
import PayoutsOverview from "./pages/payouts/PayoutsOverview";
import GiftcardsOverview from "./pages/giftcards/GiftcardsOverview";
import BillPaymentsOverview from "./pages/bill-payments/BillPaymentsOverview";
import FeesOverview from "./pages/fees/FeesOverview";
import DeexDesk from "./pages/deex-desk/DeexDesk";
import MerchantsOverview from "./pages/merchants/MerchantsOverview";
import MerchantDetail from "./pages/merchants/MerchantDetail";
import Users from "./pages/users/Users";
import NewSignupsOverview from "./pages/users/new-signups/NewSignupsOverview";
import SurveysOverview from "./pages/surveys/SurveysOverview";
import SurveyDetail from "./pages/surveys/SurveyDetail";
import SurveyBuilder from "./pages/surveys/SurveyBuilder";
import Wallet from "./pages/wallets/Wallet";
import KycLogs from "./pages/kycLogs/KycLogs";
import Compliance from "./pages/kycLogs/compliance/Compliance";
import Rules from "./pages/kycLogs/rules/Rules";
import NotFound from "./pages/NotFound";

const App = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Redirect to="/login" />} />
      <Route path="/verify-mail" element={<VerifyMail />} />
      <Route path="/" element={<Redirect to="/login" />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/wallet"
        element={
          <PrivateRoute>
            <Wallet />
          </PrivateRoute>
        }
      />

      <Route
        path="/transactions"
        element={
          <PrivateRoute>
            <Orders />
          </PrivateRoute>
        }
      />
      <Route
        path="/orders"
        element={
          <PrivateRoute>
            <OrdersOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="/deex-desk"
        element={
          <PrivateRoute>
            <DeexDesk />
          </PrivateRoute>
        }
      />
      <Route
        path="/merchants"
        element={
          <PrivateRoute>
            <MerchantsOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="/merchants/:businessId"
        element={
          <PrivateRoute>
            <MerchantDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/payouts"
        element={
          <PrivateRoute>
            <PayoutsOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="/giftcards"
        element={
          <PrivateRoute>
            <GiftcardsOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="/bill-payments"
        element={
          <PrivateRoute>
            <BillPaymentsOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="/fees"
        element={
          <PrivateRoute>
            <FeesOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="/users"
        element={
          <PrivateRoute>
            <Users />
          </PrivateRoute>
        }
      />
      <Route
        path="/users/new-signups"
        element={
          <PrivateRoute>
            <NewSignupsOverview />
          </PrivateRoute>
        }
      />

      <Route
        path="/rewards"
        element={
          <PrivateRoute>
            <RewardsOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="/invite-codes"
        element={
          <PrivateRoute>
            <InviteCodesOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="/tasks"
        element={
          <PrivateRoute>
            <Navigate to="/rewards" replace />
          </PrivateRoute>
        }
      />
      <Route
        path="/task-applications"
        element={
          <PrivateRoute>
            <TaskPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/surveys"
        element={
          <PrivateRoute>
            <SurveysOverview />
          </PrivateRoute>
        }
      />
      <Route
        path="/surveys/new"
        element={
          <PrivateRoute>
            <SurveyBuilder />
          </PrivateRoute>
        }
      />
      <Route
        path="/surveys/:surveyId/edit"
        element={
          <PrivateRoute>
            <SurveyBuilder />
          </PrivateRoute>
        }
      />
      <Route
        path="/surveys/:surveyId"
        element={
          <PrivateRoute>
            <SurveyDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <PrivateRoute>
            <Reports />
          </PrivateRoute>
        }
      />

      <Route
        path="/settings"
        element={
          <PrivateRoute>
            <Settings />
          </PrivateRoute>
        }
      />
      <Route
        path="/kyc-logs"
        element={
          <PrivateRoute>
            <KycLogs />
          </PrivateRoute>
        }
      />
      <Route
        path="/kyc-logs/compliance"
        element={
          <PrivateRoute>
            <Compliance />
          </PrivateRoute>
        }
      />
      <Route
        path="/kyc-logs/rules"
        element={
          <PrivateRoute>
            <Rules />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
